import { render } from "./v-children-list.vue?vue&type=template&id=49a3b170"
import script from "./v-children-list.vue?vue&type=script&lang=js"
export * from "./v-children-list.vue?vue&type=script&lang=js"

import exportComponent from "/builds/simplecrm/simplecrmfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__